@use "../../styles/colors";

.info {
    background-color: #E4DEFF; // Unique colour outside normal color pallete
}

.standard {
    background: colors.$peach-gradient;
}